export default "__VITE_ASSET__4XKxDhLX__"